// src/layouts/lancamentos/index.js
import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Tabs,
  Tab,
  Divider,
  Input,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  IconButton,
  FormControl,
  InputLabel,
  Box,
  InputAdornment,
  Button,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AddIcon from "@mui/icons-material/Add";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useMaterialUIController } from "context";
import { firestore } from "firebaseConfig";
import { getAuth } from "firebase/auth";
import TextField from "@mui/material/TextField";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, getDoc } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { formatCurrency } from "examples/FormatCurrency";

// ---- helpers
const parseCurrencyValue = (valueString) => {
  if (!valueString) return 0;
  if (typeof valueString === "number") return valueString;
  let cleanedValue = valueString.toString().replace(/[^0-9,.]/g, "");
  if (cleanedValue.includes(",") && cleanedValue.includes(".")) {
    cleanedValue = cleanedValue.replace(/\./g, "");
    cleanedValue = cleanedValue.replace(",", ".");
  } else if (cleanedValue.includes(",") && !cleanedValue.includes(".")) {
    cleanedValue = cleanedValue.replace(",", ".");
  } else if (cleanedValue.includes(",")) {
    const parts = cleanedValue.split(",");
    const lastPart = parts.pop();
    const integerPart = parts.join("");
    cleanedValue = `${integerPart}.${lastPart}`;
  }
  return parseFloat(cleanedValue) || 0;
};

function Lancamentos() {
  const [tabIndex, setTabIndex] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [recorrente, setRecorrente] = useState(false);
  const [parcelado, setParcelado] = useState(false);
  const [pago, setPago] = useState(false);
  const [numParcelas, setNumParcelas] = useState(1);
  const [numRecorrencias, setNumRecorrencias] = useState(1);
  const [categoria, setCategoria] = useState("");
  const [formaPagamento, setFormaPagamento] = useState("");
  const [valor, setValor] = useState("");
  const [editData, setEditData] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [lancamentos, setLancamentos] = useState([]);
  const [filteredLancamentos, setFilteredLancamentos] = useState([]);
  const [editLancamento, setEditLancamento] = useState(null);
  const [deleteLancamentoId, setDeleteLancamentoId] = useState(null);

  // --- cartões do usuário (NOVO)
  const [cartoesUsuario, setCartoesUsuario] = useState([]);
  const [cartaoId, setCartaoId] = useState(""); // escolha explícita no form

  const [controller] = useMaterialUIController();
  const { darkMode, currency } = controller;

  const [filterMonth, setFilterMonth] = useState(new Date().getMonth() + 1);
  const [filterYear, setFilterYear] = useState(new Date().getFullYear());
  const [showPending, setShowPending] = useState(false);

  const [isUserLoaded, setIsUserLoaded] = useState(false);

  const auth = getAuth();
  const user = auth.currentUser;

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        setIsUserLoaded(true);

        const loadCategorias = async () => {
          const data = await getDocs(collection(firestore, "usuarios", currentUser.uid, "categorias"));
          const categoriasData = data.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setCategorias(categoriasData);
        };

        const loadLancamentos = async () => {
          const data = await getDocs(collection(firestore, "usuarios", currentUser.uid, "lancamentos"));
          const lancamentosData = data.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setLancamentos(lancamentosData);
          filterLancamentos(lancamentosData);
        };

        // ---- carregar cartões do doc do usuário (NOVO)
        const loadCartoes = async () => {
          try {
            const userRef = doc(firestore, "usuarios", currentUser.uid);
            const snap = await getDoc(userRef);
            const arr = snap.exists() ? snap.data().cartoes || [] : [];
            setCartoesUsuario(arr.filter((c) => c.ativo !== false));
          } catch (e) {
            console.error("Erro ao carregar cartões:", e);
            setCartoesUsuario([]);
          }
        };

        await Promise.all([loadCategorias(), loadLancamentos(), loadCartoes()]);
      } else {
        setIsUserLoaded(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // se trocar a forma de pagamento, limpamos o cartão escolhido (NOVO)
  useEffect(() => {
    if (formaPagamento !== "Cartão de Crédito" && cartaoId) setCartaoId("");
  }, [formaPagamento]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateCategoryConsumption = async (categoryName, value) => {
    if (user) {
      try {
        const category = categorias.find((cat) => cat.nome === categoryName);
        if (category) {
          const categoryRef = doc(firestore, "usuarios", user.uid, "categorias", category.id);
          const currentConsumption = category.consumo || 0;
          await updateDoc(categoryRef, {
            consumo: currentConsumption + value,
          });
        }
      } catch (error) {
        console.error("Erro ao atualizar o consumo da categoria:", error);
      }
    }
  };

  const filterLancamentos = (allLancamentos) => {
    const filtered = allLancamentos.filter((lancamento) => {
      if (!lancamento.data) return false;
      const [dia, mes, ano] = lancamento.data.split("/");
      const lancamentoDate = new Date(`${ano}-${mes}-${dia}T12:00:00`);
      const isSameMonth = lancamentoDate.getUTCMonth() + 1 === filterMonth;
      const isSameYear = lancamentoDate.getUTCFullYear() === filterYear;
      const isPaid = showPending ? !lancamento.pago : true;
      return isSameMonth && isSameYear && isPaid;
    });
    setFilteredLancamentos(filtered);
  };

  useEffect(() => {
    filterLancamentos(lancamentos);
  }, [filterMonth, showPending, lancamentos]);

  const handleMonthChange = (tab, direction) => {
    setFilterMonth((prev) => {
      let newMonth = prev + direction;
      let newYear = filterYear;
      if (newMonth < 1) {
        newMonth = 12;
        newYear--;
      }
      if (newMonth > 12) {
        newMonth = 1;
        newYear++;
      }
      setFilterYear(newYear);
      return newMonth;
    });
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleValorChange = (e) => {
    let input = e.target.value.replace(/[^0-9]/g, "");
    if (!input) {
      setValor("");
      return;
    }
    const numericValue = parseInt(input, 10) / 100;
    setValor(formatCurrency(numericValue, currency));
  };

  const resetForm = () => {
    setCategoria("");
    setFormaPagamento("");
    setCartaoId(""); // NOVO
    setValor("");
    setRecorrente(false);
    setParcelado(false);
    setPago(false);
    setNumParcelas(1);
    setNumRecorrencias(1);
    setEditLancamento(null);
    setEditData("");
    setOpenPopup(false);
    setOpenEditPopup(false);
    setOpenDeletePopup(false);
  };

  const handleCadastro = async () => {
    if (!categoria || !formaPagamento || !valor) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    // validação de cartão quando necessário (NOVO)
    if (formaPagamento === "Cartão de Crédito") {
      const ativos = cartoesUsuario;
      const padrao = ativos.find((c) => c.padrao);
      if (ativos.length > 1 && !padrao && !cartaoId) {
        alert("Selecione o cartão para este lançamento.");
        return;
      }
    }

    const valorNumerico = parseCurrencyValue(valor);
    // cartaoId entra no payload apenas se o usuário escolher explicitamente (NOVO)
    const lancamentoBase = {
      categoria,
      emoji: categorias.find((cat) => cat.nome === categoria)?.emoji || "",
      formaPagamento,
      tipo: tabIndex === 0 ? "Receita" : tabIndex === 1 ? "Despesa Fixa" : "Despesa Variável",
      pago,
      recorrente,
      parcelado,
      descricao: editLancamento?.descricao || "",
      ...(formaPagamento === "Cartão de Crédito" && cartaoId ? { cartaoId } : {}),
    };

    if (user) {
      if (editLancamento && editLancamento.id) {
        const updatedLancamento = {
          ...lancamentoBase,
          valor: formatCurrency(valorNumerico, currency),
          ...(parcelado ? { numParcelas } : {}),
          ...(recorrente ? { numRecorrencias } : {}),
        };

        await updateDoc(doc(firestore, "usuarios", user.uid, "lancamentos", editLancamento.id), updatedLancamento);
        setLancamentos(lancamentos.map((l) => (l.id === editLancamento.id ? { ...l, ...updatedLancamento } : l)));
      } else {
        const lancamentosCriados = [];
        const dataAtual = editLancamento?.data
          ? new Date(editLancamento.data.split("/").reverse().join("-") + "T12:00:00")
          : new Date();

        dataAtual.setMinutes(dataAtual.getMinutes() - dataAtual.getTimezoneOffset());

        if (parcelado) {
          const valorParcela = valorNumerico / numParcelas;
          for (let i = 0; i < numParcelas; i++) {
            const dataParcela = new Date(dataAtual);
            dataParcela.setMonth(dataParcela.getMonth() + i);
            const novaData = dataParcela.toLocaleDateString("pt-BR");

            const lancamentoParcela = {
              ...lancamentoBase,
              data: novaData,
              valor: formatCurrency(valorParcela, currency),
              pago: i === 0 ? pago : false,
              parcelaInfo: `${i + 1}/${numParcelas}`,
              descricao: editLancamento?.descricao || "",
            };

            const docRef = await addDoc(collection(firestore, "usuarios", user.uid, "lancamentos"), lancamentoParcela);
            lancamentosCriados.push({ id: docRef.id, ...lancamentoParcela });

            if (lancamentoParcela.pago) {
              await updateCategoryConsumption(categoria, valorParcela);
            }
          }
        } else if (recorrente) {
          for (let i = 0; i < numRecorrencias; i++) {
            const dataRecorrencia = new Date(dataAtual);
            dataRecorrencia.setMonth(dataRecorrencia.getMonth() + i);
            const novaData = dataRecorrencia.toLocaleDateString("pt-BR");

            const lancamentoRecorrencia = {
              ...lancamentoBase,
              data: novaData,
              valor: formatCurrency(valorNumerico, currency),
              pago: i === 0 ? pago : false,
              recorrente: true,
              numRecorrencias: numRecorrencias,
              recorrenciaAtual: i + 1,
              descricao: editLancamento?.descricao || "",
            };

            const docRef = await addDoc(
              collection(firestore, "usuarios", user.uid, "lancamentos"),
              lancamentoRecorrencia
            );
            lancamentosCriados.push({ id: docRef.id, ...lancamentoRecorrencia });

            if (lancamentoRecorrencia.pago) {
              await updateCategoryConsumption(categoria, valorNumerico);
            }
          }
        } else {
          const lancamentoSimples = {
            ...lancamentoBase,
            data: dataAtual.toLocaleDateString("pt-BR"),
            valor: formatCurrency(valorNumerico, currency),
            descricao: editLancamento?.descricao || "",
          };

          const docRef = await addDoc(collection(firestore, "usuarios", user.uid, "lancamentos"), lancamentoSimples);
          lancamentosCriados.push({ id: docRef.id, ...lancamentoSimples });

          if (pago) {
            await updateCategoryConsumption(categoria, valorNumerico);
          }
        }

        setLancamentos([...lancamentos, ...lancamentosCriados]);
      }
    }

    resetForm();
  };

  const handleEdit = (lancamento) => {
    setEditLancamento(lancamento);
    setValor(lancamento.valor);
    setPago(lancamento.pago || false);
    setEditData(lancamento.data ? lancamento.data.split("/").reverse().join("-") : "");
    setOpenEditPopup(true);
  };

  const handleSaveEdit = async () => {
    if (!valor || !editData) {
      alert("Preencha todos os campos obrigatórios!");
      return;
    }

    const valorNumerico = parseCurrencyValue(valor);
    const dataFormatada = new Date(editData + "T12:00:00").toLocaleDateString("pt-BR");

    if (user && editLancamento && editLancamento.id) {
      const updatedLancamento = {
        ...editLancamento,
        data: dataFormatada,
        valor: formatCurrency(valorNumerico, currency),
        pago,
      };

      await updateDoc(doc(firestore, "usuarios", user.uid, "lancamentos", editLancamento.id), updatedLancamento);
      setLancamentos(lancamentos.map((l) => (l.id === editLancamento.id ? updatedLancamento : l)));

      if (updatedLancamento.pago && !editLancamento.pago) {
        await updateCategoryConsumption(updatedLancamento.categoria, valorNumerico);
      }
    }

    resetForm();
  };

  const handleDeleteConfirmation = (id) => {
    setDeleteLancamentoId(id);
    setOpenDeletePopup(true);
  };

  const handleDelete = async () => {
    if (deleteLancamentoId && user) {
      await deleteDoc(doc(firestore, "usuarios", user.uid, "lancamentos", deleteLancamentoId));
      setLancamentos(lancamentos.filter((lancamento) => lancamento.id !== deleteLancamentoId));
    }
    resetForm();
  };

  const handleTogglePago = async (lancamento) => {
    if (user) {
      const updatedLancamento = { ...lancamento, pago: !lancamento.pago };
      await updateDoc(doc(firestore, "usuarios", user.uid, "lancamentos", lancamento.id), updatedLancamento);
      setLancamentos(lancamentos.map((l) => (l.id === lancamento.id ? updatedLancamento : l)));

      if (updatedLancamento.pago) {
        await updateCategoryConsumption(updatedLancamento.categoria, parseCurrencyValue(updatedLancamento.valor));
      }
    }
  };

  const renderForm = () => (
    <Dialog
      open={openPopup}
      onClose={() => {
        resetForm();
        setOpenPopup(false);
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: (theme) => ({
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          boxShadow: theme.shadows[5],
          borderRadius: "12px",
        }),
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>
          {editLancamento
            ? "Editar Lançamento"
            : tabIndex === 0
            ? "Cadastrar Receita"
            : tabIndex === 1
            ? "Cadastrar Despesa Fixa"
            : "Cadastrar Despesa Variável"}
        </span>
        <IconButton
          onClick={() => {
            resetForm();
            setOpenPopup(false);
          }}
          sx={{ color: darkMode ? "#B0BEC5" : "grey.600" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {/* Data e Categoria */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Data"
              type="date"
              value={editLancamento?.data ? editLancamento.data.split("/").reverse().join("-") : ""}
              onChange={(e) => setEditLancamento({ ...editLancamento, data: e.target.value })}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarTodayIcon sx={{ color: "gray", fontSize: 16 }} />
                  </InputAdornment>
                ),
                sx: { height: "40px", pl: 2 },
              }}
              sx={{ mt: 2 }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              select
              fullWidth
              label="Categoria"
              value={categoria || ""}
              onChange={(e) => setCategoria(e.target.value)}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{ sx: { height: "40px" } }}
              sx={{ mt: 2 }}
            >
              {categorias
                .filter((cat) =>
                  tabIndex === 0
                    ? cat.tipo === "receita"
                    : tabIndex === 1
                    ? cat.tipo === "despesaFixa"
                    : cat.tipo === "despesaVariavel"
                )
                .map((cat) => (
                  <MenuItem key={cat.id} value={cat.nome}>
                    {`${cat.emoji || ""} ${cat.nome}`}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>

          {/* Método de pagamento e Valor */}
          <Grid item xs={12} md={6}>
            <TextField
              select
              fullWidth
              label="Método de Pagamento"
              value={formaPagamento || ""}
              onChange={(e) => setFormaPagamento(e.target.value)}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{ sx: { height: "40px" } }}
              sx={{ mt: 2 }}
            >
              <MenuItem value="Dinheiro">💵 Dinheiro</MenuItem>
              <MenuItem value="Transferência/Pix">📲 Transferência/Pix</MenuItem>
              <MenuItem value="Cartão de Crédito">💳 Cartão de Crédito</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Valor"
              placeholder={formatCurrency(0, currency)}
              value={valor}
              onChange={handleValorChange}
              variant="outlined"
              InputProps={{ sx: { height: "40px" } }}
              sx={{ mt: 2 }}
            />
          </Grid>

          {/* Se for Cartão, escolher qual (NOVO) */}
          {formaPagamento === "Cartão de Crédito" && (
            <Grid item xs={12}>
              <Select
                fullWidth
                value={cartaoId}
                onChange={(e) => setCartaoId(e.target.value)}
                displayEmpty
                sx={{ height: 42, borderRadius: "10px" }}
                renderValue={(value) => {
                  const ativos = cartoesUsuario;
                  const padrao = ativos.find((c) => c.padrao);
                  if (!value) {
                    return padrao
                      ? `Usar cartão padrão (${(padrao.bandeira || "cartão").toUpperCase()})`
                      : "Selecione o cartão";
                  }
                  const c = ativos.find((c) => c.id === value);
                  return c ? `Cartão: ${(c.bandeira || "cartão").toUpperCase()}` : "Selecione o cartão";
                }}
              >
                <MenuItem value="">
                  <em>{cartoesUsuario.some((c) => c.padrao) ? "Usar cartão padrão" : "Selecione o cartão"}</em>
                </MenuItem>
                {cartoesUsuario.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {(c.bandeira || "outro").toUpperCase()} {c.padrao ? "• Padrão" : ""}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}

          {/* Pago */}
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ border: "1px solid", borderColor: "grey.300", borderRadius: "4px", p: 2 }}
            >
              <Box>
                <MDTypography variant="body2" fontWeight="medium">
                  Está pago?
                </MDTypography>
                <MDTypography variant="caption" color="textSecondary">
                  Marque se este lançamento já foi pago
                </MDTypography>
              </Box>
              <Switch checked={pago} onChange={(e) => setPago(e.target.checked)} />
            </Box>
          </Grid>

          {/* Campo Recorrente */}
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                border: "1px solid",
                borderColor: "grey.300",
                borderRadius: "4px",
                p: 2,
              }}
            >
              <Box>
                <MDTypography variant="body2" fontWeight="medium">
                  É recorrente?
                </MDTypography>
                <MDTypography variant="caption" color="textSecondary">
                  Marque se este lançamento se repete mensalmente
                </MDTypography>
              </Box>
              <Switch checked={recorrente} onChange={(e) => setRecorrente(e.target.checked)} />
            </Box>
            {recorrente && (
              <TextField
                fullWidth
                label="Recorrências"
                type="number"
                value={numRecorrencias}
                onChange={(e) => setNumRecorrencias(e.target.value)}
                variant="outlined"
                sx={{ mt: 1 }}
                InputProps={{ sx: { height: "40px" } }}
              />
            )}
          </Grid>

          {/* Parcelado */}
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ border: "1px solid", borderColor: "grey.300", borderRadius: "4px", p: 2 }}
            >
              <Box>
                <MDTypography variant="body2" fontWeight="medium">
                  É parcelado?
                </MDTypography>
                <MDTypography variant="caption" color="textSecondary">
                  Marque se este lançamento é parcelado
                </MDTypography>
              </Box>
              <Switch checked={parcelado} onChange={(e) => setParcelado(e.target.checked)} />
            </Box>
            {parcelado && (
              <TextField
                fullWidth
                label="Parcelas"
                type="number"
                value={numParcelas}
                onChange={(e) => setNumParcelas(e.target.value)}
                variant="outlined"
                sx={{ mt: 1 }}
                InputProps={{ sx: { height: "40px" } }}
              />
            )}
          </Grid>

          {/* Notas */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Notas"
              placeholder="Adicione informações adicionais sobre o lançamento"
              value={editLancamento?.descricao || ""}
              onChange={(e) => setEditLancamento({ ...editLancamento, descricao: e.target.value })}
              variant="outlined"
              multiline
              rows={3}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <MDButton onClick={handleCadastro} color="info">
          {editLancamento ? "Salvar Alterações" : "Cadastrar"}
        </MDButton>
      </DialogActions>
    </Dialog>
  );

  const renderEditForm = () => (
    <Dialog
      open={openEditPopup}
      onClose={() => {
        resetForm();
        setOpenEditPopup(false);
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: (theme) => ({
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          boxShadow: theme.shadows[5],
          borderRadius: "12px",
        }),
      }}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>Editar Lançamento</span>
        <IconButton
          onClick={() => {
            resetForm();
            setOpenEditPopup(false);
          }}
          sx={{ color: darkMode ? "#B0BEC5" : "grey.600" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {/* Data */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Data"
              type="date"
              value={editData}
              onChange={(e) => setEditData(e.target.value)}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarTodayIcon sx={{ color: "gray", fontSize: 16 }} />
                  </InputAdornment>
                ),
                sx: { height: "40px", pl: 2 },
              }}
              sx={{ mt: 2 }}
            />
          </Grid>

          {/* Valor */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Valor"
              placeholder={formatCurrency(0, currency)}
              value={valor}
              onChange={handleValorChange}
              variant="outlined"
              InputProps={{ sx: { height: "40px" } }}
              sx={{ mt: 2 }}
            />
          </Grid>

          {/* Pago */}
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ border: "1px solid", borderColor: "grey.300", borderRadius: "4px", p: 2 }}
            >
              <Box>
                <MDTypography variant="body2" fontWeight="medium">
                  Está pago?
                </MDTypography>
                <MDTypography variant="caption" color="textSecondary">
                  Marque se este lançamento já foi pago
                </MDTypography>
              </Box>
              <Switch checked={pago} onChange={(e) => setPago(e.target.checked)} />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={handleSaveEdit} color="info">
          Salvar Alterações
        </MDButton>
      </DialogActions>
    </Dialog>
  );

  const renderDeleteConfirmation = () => (
    <Dialog
      open={openDeletePopup}
      onClose={() => setOpenDeletePopup(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: (theme) => ({
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          boxShadow: theme.shadows[5],
          borderRadius: "12px",
        }),
      }}
    >
      <DialogTitle>Confirmar Exclusão</DialogTitle>
      <DialogContent>
        <p>Tem certeza que deseja excluir este lançamento?</p>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={() => setOpenDeletePopup(false)} color="secondary">
          Cancelar
        </MDButton>
        <MDButton onClick={handleDelete} color="error">
          Excluir
        </MDButton>
      </DialogActions>
    </Dialog>
  );

  // totais
  const currentMonthTotal = filteredLancamentos.reduce((acc, lancamento) => {
    const value = parseCurrencyValue(lancamento.valor);
    return acc + (lancamento.tipo === "Receita" ? value : -value);
  }, 0);

  const currentMonthPaidTotal = filteredLancamentos
    .filter(
      (lancamento) =>
        lancamento.pago &&
        lancamento.tipo === (tabIndex === 0 ? "Receita" : tabIndex === 1 ? "Despesa Fixa" : "Despesa Variável")
    )
    .reduce((acc, lancamento) => acc + parseCurrencyValue(lancamento.valor), 0);

  const getColorByType = (type) => {
    switch (type) {
      case "Receita":
        return "blue";
      case "Despesa Fixa":
        return "red";
      case "Despesa Variável":
        return "darkorange";
      default:
        return darkMode ? "#ffffff" : "#000000";
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={2} px={3}></MDBox>

        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          centered
          variant="fullWidth"
          sx={{
            p: 0.5,
            mx: "auto",
            width: { xs: "100%", sm: "auto" },
            borderRadius: 9999,
            background: darkMode ? "rgba(17,25,40,0.55)" : "rgba(255,255,255,0.65)",
            border: darkMode ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(30,136,229,0.15)",
            boxShadow: darkMode ? "0 6px 18px rgba(0,0,0,0.35)" : "0 6px 18px rgba(30,136,229,0.08)",
            backdropFilter: "saturate(180%) blur(8px)",
            "& .MuiTabs-indicator": { display: "none" },

            "& .MuiTab-root": {
              minHeight: 40,
              borderRadius: 9999,
              textTransform: "none",
              fontWeight: 700,
              fontSize: { xs: "0.9rem", md: "1rem" },
              px: { xs: 1.5, md: 2.5 },
              transition: "all .2s ease",
              color: darkMode ? "rgba(255,255,255,0.72)" : "#5E7FA3",

              "&:hover": {
                backgroundColor: darkMode ? "rgba(255,255,255,0.06)" : "rgba(221,241,255,0.7)",
              },

              "&.Mui-selected": {
                color: darkMode ? "#A6D9FF" : "#1565D8",
                background: darkMode
                  ? "linear-gradient(180deg, rgba(42,56,76,0.9) 0%, rgba(26,33,46,0.9) 100%)"
                  : "linear-gradient(180deg, #E6F5FF 0%, #F4FAFF 100%)",
                border: darkMode ? "1px solid rgba(166,217,255,0.35)" : "1px solid #BFE7FF",
                boxShadow: darkMode
                  ? "0 6px 14px rgba(0,0,0,0.40), inset 0 -2px 0 rgba(166,217,255,0.12)"
                  : "0 6px 14px rgba(21,101,216,0.12), inset 0 -2px 0 rgba(21,101,216,0.06)",
              },
            },
          }}
        >
          <Tab label="Receitas" />
          <Tab label="Despesas Fixas" />
          <Tab label="Despesas Variáveis" />
        </Tabs>
        <Divider />
        <MDBox mt={3} textAlign="center">
          <MDButton
            startIcon={<AddIcon />}
            onClick={() => setOpenPopup(true)}
            sx={{
              height: 36,
              borderRadius: "10px",
              px: 2,
              backgroundColor: darkMode ? "#444" : "#fff",
              color: darkMode ? "#fff" : "#1976d2",
              border: darkMode ? "1px solid #666" : "1px solid #ddd",
              textTransform: "none",
              fontSize: "0.9rem",
              "&:hover": { backgroundColor: darkMode ? "#555" : "#f0f0f0" },
            }}
          >
            {tabIndex === 0
              ? "Adicionar Receita"
              : tabIndex === 1
              ? "Adicionar Despesa Fixa"
              : "Adicionar Despesa Variável"}
          </MDButton>
        </MDBox>
      </MDBox>

      <MDBox mt={3}>
        <Card>
          <MDBox p={2} sx={{ borderBottom: "1px solid #e0e0e0" }}>
            {/* Filtro mês/ano DENTRO do card */}
            <MDBox display="flex" justifyContent="center" alignItems="center" mb={2}>
              <Button
                onClick={() => handleMonthChange(tabIndex + 1, -1)}
                sx={{
                  minWidth: "24px",
                  height: "24px",
                  color: darkMode ? "#fff" : "#333",
                  "&:hover": { backgroundColor: "transparent" },
                  "&:before": { content: '"◄"', fontSize: "16px", display: "inline-block" },
                  "&:after": { content: "none" },
                }}
              />
              <MDTypography
                variant="h6"
                fontWeight="bold"
                sx={{ mx: 2, textAlign: "center", minWidth: "120px", color: darkMode ? "#90caf9" : "#1976d2" }}
              >
                {
                  [
                    "Janeiro",
                    "Fevereiro",
                    "Março",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro",
                  ][filterMonth - 1]
                }{" "}
                {filterYear}
              </MDTypography>
              <Button
                onClick={() => handleMonthChange(tabIndex + 1, 1)}
                sx={{
                  minWidth: "24px",
                  height: "24px",
                  color: darkMode ? "#fff" : "#333",
                  "&:hover": { backgroundColor: "transparent" },
                  "&:before": { content: '"►"', fontSize: "16px", display: "inline-block" },
                  "&:after": { content: "none" },
                }}
              />
            </MDBox>

            {/* KPIs */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6} sm={6}>
                <MDBox sx={{ display: "flex", alignItems: "flex-start", p: 1, borderRadius: "8px" }}>
                  <AttachMoneyIcon sx={{ mr: 1, color: "grey.600", mt: 0.5 }} />
                  <Box>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      Saldo Mensal
                    </MDTypography>
                    {/* Verde se >= 0, vermelho se < 0 */}
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      sx={{ color: currentMonthTotal >= 0 ? "green" : "red" }}
                    >
                      {formatCurrency(currentMonthTotal, currency)}
                    </MDTypography>
                  </Box>
                </MDBox>
              </Grid>
              <Grid item xs={6} sm={6}>
                <MDBox sx={{ display: "flex", alignItems: "flex-start", p: 1, borderRadius: "8px" }}>
                  {tabIndex === 0 ? (
                    <TrendingUpIcon sx={{ mr: 1, color: "grey.600", mt: 0.5 }} />
                  ) : (
                    <TrendingDownIcon sx={{ mr: 1, color: "grey.600", mt: 0.5 }} />
                  )}
                  <Box>
                    <MDTypography variant="h6" fontWeight="bold" color="text.primary">
                      Total Lançado
                    </MDTypography>
                    <MDTypography
                      variant="h6"
                      fontWeight="bold"
                      style={{ color: tabIndex === 0 ? "blue" : tabIndex === 1 ? "red" : "darkorange" }}
                    >
                      {formatCurrency(currentMonthPaidTotal, currency)}
                    </MDTypography>
                  </Box>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>

          <MDBox p={3}>
            <Grid container spacing={1} alignItems="center" justifyContent="space-between" flexWrap="wrap">
              <Grid item xs={12}>
                <MDBox
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  flexDirection="row"
                  flexWrap="nowrap"
                  justifyContent="flex-end"
                  sx={{
                    width: "100%",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": { display: "none" },
                    scrollbarWidth: "none",
                  }}
                >
                  <FormControlLabel
                    control={<Switch checked={!showPending} onChange={(e) => setShowPending(!e.target.checked)} />}
                    label="Pago"
                    labelPlacement="end"
                    sx={{
                      color: darkMode ? "#fff" : "#333",
                      padding: "6px 6px",
                      margin: 0,
                      minWidth: "80px",
                      flexShrink: 0,
                      display: "flex",
                      justifyContent: "center",
                      "& .MuiFormControlLabel-label": { fontSize: "0.9rem", textAlign: "center" },
                    }}
                  />
                </MDBox>
              </Grid>
            </Grid>

            <MDBox mt={3}>
              {Object.entries(
                filteredLancamentos
                  .filter(
                    (lancamento) =>
                      lancamento.tipo ===
                      (tabIndex === 0 ? "Receita" : tabIndex === 1 ? "Despesa Fixa" : "Despesa Variável")
                  )
                  .reduce((acc, lancamento) => {
                    if (!acc[lancamento.data]) acc[lancamento.data] = [];
                    acc[lancamento.data].push(lancamento);
                    return acc;
                  }, {})
              )
                .filter(([, lancamentos]) => lancamentos.length > 0)
                .sort(([dataA], [dataB]) => {
                  const [diaA, mesA, anoA] = dataA.split("/");
                  const [diaB, mesB, anoB] = dataB.split("/");
                  const dateA = new Date(`${anoA}-${mesA}-${diaA}T12:00:00`);
                  const dateB = new Date(`${anoB}-${mesB}-${diaB}T12:00:00`);
                  return dateB - dateA;
                })
                .map(([data, lancamentos]) => (
                  <div key={data} style={{ marginBottom: "24px" }}>
                    <p style={{ margin: "8px 0", fontWeight: "bold", color: "orchid", fontSize: "16px" }}>
                      {new Date(data.split("/").reverse().join("-") + "T12:00:00").toLocaleDateString("pt-BR", {
                        weekday: "long",
                        day: "2-digit",
                        month: "short",
                      })}
                    </p>

                    {lancamentos.map((lancamento, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "16px",
                          color: darkMode ? "#fff" : "#000",
                        }}
                      >
                        <div>
                          <p style={{ margin: 0, fontWeight: "bold", fontSize: "16px" }}>
                            {lancamento.emoji} {lancamento.categoria}
                          </p>
                          <p style={{ margin: 0, fontSize: "14px", color: darkMode ? "#ccc" : "gray" }}>
                            {lancamento.formaPagamento} <br />
                            {lancamento.descricao || "Nenhuma observação"} <br />
                            <span style={{ color: lancamento.pago ? "green" : "red", fontWeight: "bold" }}>
                              {lancamento.pago ? "Pago" : "Pendente"}
                            </span>
                          </p>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <p
                            style={{
                              margin: 0,
                              fontWeight: "bold",
                              fontSize: "16px",
                              color:
                                lancamento.tipo === "Receita"
                                  ? "blue"
                                  : lancamento.tipo === "Despesa Fixa"
                                  ? "red"
                                  : "darkorange",
                            }}
                          >
                            {formatCurrency(parseCurrencyValue(lancamento.valor), currency)}
                          </p>
                          <div>
                            <IconButton onClick={() => handleEdit(lancamento)}>
                              <EditIcon color="warning" />
                            </IconButton>
                            <IconButton onClick={() => handleDeleteConfirmation(lancamento.id)}>
                              <DeleteIcon color="error" />
                            </IconButton>
                            <IconButton onClick={() => handleTogglePago(lancamento)}>
                              {lancamento.pago ? (
                                <CheckCircleIcon color="success" />
                              ) : (
                                <RadioButtonUncheckedIcon style={{ color: "gray" }} />
                              )}
                            </IconButton>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      {renderForm()}
      {renderEditForm()}
      {renderDeleteConfirmation()}
    </DashboardLayout>
  );
}

export default Lancamentos;
